<template>
  <v-dialog v-model="dialog" persistent max-width="900px">
    <v-card>
      <v-card-title>Create your profile</v-card-title>
      <v-card-text :style="$vuetify.breakpoint.xsOnly ? 'padding:4px' : ''">
        <v-form v-if="loaded">
          <EditForm :items="requiredFields" createNew ref="editForm" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container>
        <v-row>
          <v-col cols="12" offset-xs="2" offset-md="4" md="4">
            <v-btn block @click="create" style="margin-top:-24px" class="mb-4">Create</v-btn>
          </v-col>
        </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import EditForm from '@/components/public/EditForm'
import ProfileService from '@/services/ProfileService.js'

const ProfileModule = namespace('profile')

@Component({
  components: {
    EditForm
  }
})
export default class CreateProfileDialog extends Vue {
  dialog = false
  loaded = false

  @ProfileModule.Getter requiredFields

  mounted () {
    this.loaded = true
  }

  open () {
    this.dialog = true
  }

  close () {
    this.dialog = false
  }

  create () {
    const data = {}
    this.$refs.editForm.fields.map(item => {
      data[item.name] = item.value
    })

    ProfileService.create(data)
      .then(resp => {
        location.href = '/profile'
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.close()
      })
  }
}
</script>
